// extracted by mini-css-extract-plugin
export default {"changeQuestion":"styles_changeQuestion__y4bSj","show":"styles_show__ERNfN"};